export default [
    {
        title: '专栏管理',
        path: '/specialColumn',
        name: 'specialColumn',
        meta: {
            key: 'specialColumn'
        },
        permission: 'specialColumn',
        menu: true,
        children: [
            {
                title: '栏目管理',
                path: '/specialColumn/list',
                name: 'specialColumnList',
                component: () => import('@/views/specialColumn/list'),
                meta: {
                    key: 'specialColumnList',
                    open: 'specialColumn'
                },
                permission: 'specialColumnList'
            },
            {
                title: '文章管理',
                path: '/specialColumn/article',
                name: 'specialColumnArticle',
                component: () => import('@/views/specialColumn/article'),
                meta: {
                    key: 'specialColumnArticle',
                    open: 'specialColumn'
                },
                permission: 'specialColumnArticle'
            },
            {
                title: '咨询管理',
                path: '/specialColumn/consultation',
                name: 'specialColumnConsultation',
                component: () => import('@/views/specialColumn/consultation'),
                meta: {
                    key: 'specialColumnConsultation',
                    open: 'specialColumn'
                },
                permission: 'specialColumnConsultation'
            }
        ]
    },
    {
        title: '专栏文章表单',
        path: '/specialColumn/article/form',
        name: 'specialColumnArticleForm',
        component: () => import('@/views/specialColumn/articleForm'),
        meta: {
            key: 'specialColumnArticle',
            open: 'specialColumn'
        },
        permission: false
    }
];
